export default __webpack_public_path__ + "static/media/loanbuilder_paypal--horizontal.55b19177.svg";